<ul class="sub-menu-v2 active">
    <li sidebar2-checkbox-dropdown class="active" [ngClass]="{ open: dropdownOpen, disabled: disableFilter }">
        <ul class="sub-menu-v2--dropdown">
            <li [ngClass]="{ 'dropdown-item-zero': total < 1 }">
                <input
                    legacy-css
                    type="checkbox"
                    name="status"
                    [checked]="allChecked"
                    [attr.value]="'All'"
                    (click)="toggleAll($event)"
                    class="sub-menu-v2-cb"
                    [attr.id]="'leads_cb_all'" /><label [attr.for]="'leads_cb_all'"
                    >All
                    <span class="badge badge-stats pull-right">{{ total }}</span>
                </label>
            </li>
            <li
                *ngFor="let item of statuses; let i = index"
                [ngClass]="{ 'dropdown-item-zero': item.count < 1, 'dropdown-item-inset': item.status !== 'All' }">
                <input
                    legacy-css
                    type="checkbox"
                    name="status[]"
                    [checked]="item.selected"
                    [attr.value]="item.status"
                    (click)="toggleSelection($event)"
                    class="sub-menu-v2-cb"
                    [attr.id]="'leads_cb' + i" /><label [attr.for]="'leads_cb' + i"
                    >{{ item.status | titlecase }}
                    <span class="badge badge-stats pull-right">{{ item.count }}</span>
                </label>
            </li>
        </ul>
    </li>
</ul>
